import { useViewModel } from '../ShopTheLookSection/useViewModel'

const useFetchDefault = (productHandle: string) => {
  const { shopTheLookProducts, loading } = useViewModel({
    productHandle: productHandle,
    isKit: false,
  })
  const product = shopTheLookProducts?.[0] // defaults to first shopTheLook product

  return {
    product,
    loading,
  }
}

export default useFetchDefault
